import { Observable } from 'rxjs';
import { verifyAuthTokenModel } from '../../auth/verify-Auth-Token';

export abstract class MfaGateway {
    abstract sendAuthCode(): Observable<any>
    abstract verifyAuthenticationCode(mfaRequestModel: verifyAuthTokenModel): Observable<any>
}
